import React from "react";
import "./Footer.compact.css";

const Footer = () => {
  return (
    <>
      <div className="footer-compact">
        {/* Login Modal */}
        <div
          className="modal fade"
          id="loginModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="loginModalTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <a title="Close" className="close">
                <img
                  src={require("../../assets/images/closebtn.png")}
                  alt="close Modal"
                  className="_2jZ45"
                />
              </a>
              <div className="modal-body">
                <div className="logindiv">
                  <div className="logintext">
                    <strong>
                      Use mobile version from Google Play Store to Create a
                      profile, Add your business or Log into your Trust account
                    </strong>
                    <div className="loginSteps">
                      <ul>
                        <li>
                          <span className="index">1.</span>
                          <span className="text">
                            Scan or Click{" "}
                            <a
                              href="https://play.google.com/store/apps/details?id=com.trustapp"
                              target="_blank"
                            >
                              {" "}
                              link{" "}
                            </a>{" "}
                            to download <strong>Trust app</strong> from Google
                            Play Store
                          </span>
                        </li>
                        <li>
                          <span className="index">2.</span>
                          <span className="text">
                            Scan QR
                            <img
                              className="icon"
                              src={
                                require("../../assets/images/q-rcode.svg")
                              }
                              alt="QR code"
                            />{" "}
                            to go to Google play store
                          </span>
                        </li>
                        <li>
                          <span className="index">3.</span>
                          <span className="text">
                            Install app then login or create profile
                          </span>
                        </li>
                        <li>
                          <span className="index">4.</span>
                          <span className="text">
                            To add your Business or profession, first create a
                            profile in app then change the profile to Service
                            Provider profile. Same profile can be used as a
                            customer and as a Service Provider
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="watchVideoButton">
                      <a
                        href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                        target="_blank"
                      >
                        <img
                          src={
                            require("../../assets/images/video-icon.svg")
                          }
                          alt="Watch Video"
                        />
                        <span>Watch TrustApp steps and settings Video</span>
                      </a>
                    </div>
                    <div className="cta-description">
                      To create an account download Trust App ( Android )
                    </div>
                    <div className="actionContainer">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.trustapp"
                        target="_blank"
                      >
                        <img
                          className="icon"
                          src={
                            require("../../assets/images/googleplay.svg")
                          }
                          alt="Google Play"
                        />
                        Google Play
                      </a>
                      <a
                        href="https://apps.apple.com/us/app/apple-store/id1479704788"
                        target="_blank"
                      >
                        <img
                          className="icon"
                          src={
                            require("../../assets/images/appstore.svg")
                          }
                          alt="App Store"
                        />
                        App Store
                      </a>
                    </div>
                  </div>
                  <div className="qrcode">
                    <img
                      src={require("../../assets/images/QR-CODE.jpeg")}
                      alt="QR Code"
                    />
                    <p>Scan QR code to download Trust App</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ul className="list-unstyled ft_mainul">
                  <li>
                    <div className="ftlogo">
                      <a href="/">
                        <img
                          src={require("../../assets/images/logo.png")}
                          alt="Trust Logo"
                        />
                      </a>
                      <p>
                        Commisson FREE app for more than 400 businesses. Start
                        your own delivery business in 10 minutes!
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="ftcontact">
                      <h6>Contact Us</h6>
                      <div style={{ display: "flex" }}>
                        <a>
                          <i className="fas fa-map-marker-alt"></i>
                        </a>
                        <p>WeWork, Embassy TechVillage, Bellandur, Bangalore (India)</p>
                      </div>
                      <div style={{ display: "flex" }}>
                        <a>
                          <i className="fas fa-map-marker-alt"></i>
                        </a>
                        <p>
                          WeWork Frankfurt am Main, DE 60313 Frankfurt am Main
                          (Germany)
                        </p>
                      </div>
                      <a href="mailto:trustapp@cloudai.in">
                        <i className="fas fa-envelope-open-text"></i>{" "}
                        trustapp@cloudai.in
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="Quicklink">
                      <h6>Quick Links</h6>
                      <a
                        href="https://cloudai.in/trust-pp.html"
                        target="_blank"
                      >
                        Privacy
                      </a>
                      <a
                        href="https://cloudai.in/trust-tos.html"
                        target="_blank"
                      >
                        Terms & Condition
                      </a>
                      <a
                        href="https://cloudai.in/trust-cm.html"
                        target="_blank"
                      >
                        Legal and Compliance
                      </a>
                      <a href="#">GST : 29AAICC0770A1ZZ</a>
                      <a href="https://cloudai.in" target="_blank">
                        CloudAI Pvt Ltd
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="ft_follow">
                      <h6>Follow Us</h6>
                      <a
                        href="https://www.facebook.com/trust.cloudai"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fab fa-facebook"
                      ></a>
                      <a
                        href="https://twitter.com/trust__app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fab fa-twitter"
                      ></a>
                      <a
                        href="https://www.instagram.com/trust_app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fab fa-instagram"
                      ></a>
                      <a
                        href="https://www.linkedin.com/company/trust-mobile-app/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fab fa-linkedin"
                      ></a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

        {/* Copyright */}
        <div className="copyright">
          <span>Copyright © 2019-2030 CloudAI PVT.LTD.</span>
        </div>
      </div>
    </>
  );
};

export default Footer;
